import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useApis } from '../../../api/useApiClient';
import { useNotification } from "../../../context/NotificationContext";


import {
    Grid, Stack, Box, LinearProgress
} from '@mui/material';

import WorkOrderItemsList from './POS/WorkOrderItemsList';

import POSHeader from './POS/POSHeader';
import CustomerSelector from './POS/CustomerSelector';
import VehicleSelector from './POS/VehicleSelector';
import POSCheckout from './POS/POSCheckout';

export default function POS() {

    const { workOrderId } = useParams(); // work order id
    const { tenantApi } = useApis();
    const { showNotification } = useNotification();

    const [workOrder, setWorkOrder] = useState({});
    const [loading, setLoading] = useState(true);
    const [selectedCustomerId, setSelectedCustomerId] = useState(null);

    useEffect(() => {
        loadWorkOrder();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workOrderId]);

    // Debug
    useEffect(() => {
        console.log("Loaded work order:", workOrder);
        // Initialize selected customer from work order data
        setSelectedCustomerId(workOrder?.customerId || null);
    }, [workOrder]);

    const loadWorkOrder = async () => {
        try {
            setLoading(true);
            const workOrderRes = await tenantApi(`/tenants/work-orders/${workOrderId}`);
            setWorkOrder(workOrderRes.data);
        } catch (e) {
            console.error(e);
            if (e.message)
                showNotification(e.message, "error");
            else
                showNotification(`Failed to load order details. Please try again later.`, "error");

        } finally {
            setLoading(false);
        }
    };

    const handleCustomerChange = (customer) => {
        setSelectedCustomerId(customer?.id || null);
    };

    return (
        <Grid container spacing={2} sx={{ p: 2 }} alignItems="stretch">
            <Grid item xs={12}>
                {loading && <LinearProgress />}
            </Grid>
            {/* Left Panel - POS Header, Customer & Items Selection */}
            <Grid item xs={12} md={4}>
                <POSHeader workOrder={workOrder} loading={loading} />
            </Grid>
            <Grid item xs={12} md={4}>
                <CustomerSelector 
                    workOrder={workOrder} 
                    disabled={loading} 
                    onCustomerChange={handleCustomerChange}
                />
            </Grid>

            <Grid item xs={12} md={4}>
                <VehicleSelector 
                    workOrder={workOrder} 
                    customerId={selectedCustomerId}
                    disabled={loading} 
                />
            </Grid>
            
            <Grid item xs={12}>
                <WorkOrderItemsList workOrder={workOrder} apiClient={tenantApi} disabled={loading} />
            </Grid>

            <Grid item xs={12}>
                <POSCheckout workOrder={workOrder} apiClient={tenantApi} disabled={loading} />
            </Grid>


        </Grid >
    );
}
